import * as React from 'react';
import { Card } from "react-bootstrap";

export interface ChangeBankingDetailsDisclosureProps {
    premium: string;
    textAlign?: string;
    showSecure?: boolean;
}

export class ChangeBankingDetailsDisclosure extends React.Component<ChangeBankingDetailsDisclosureProps, any> {
    constructor(props: ChangeBankingDetailsDisclosureProps) {
        super(props);
    }

    public render() {
        return (
            <Card>
                <Card.Body>
                    <div className="row px-3 justify-content-center">
                        <div className="col-12">
                            { this.props.children }
                        </div>
                        <div className="col-12">
                            <p className={ this.props.textAlign ? this.props.textAlign : 'text-center'}>
                                Do you confirm that the account specified belongs to you and that you authorise
                                'King Price' to debit the amount of <b>R { this.props.premium } per month</b>? The amount deducted will
                                reflect as King Price on your bank statement.
                            </p>
                        </div>
                         { this.props.showSecure && <div className="col-12 text-center row justify-content-center align-items-center flex-nowrap">
                            <div className="col-auto">
                                <img className="d-inline-block" src="./Images/LifeInsurance/icon-lock.png" />
                            </div>
                            <div className="col-auto">
                                <p className="d-inline-block text-left text-md-center mb-0">
                                    <b>Secure connection</b>. Your info’s encrypted, which means it’s totally safe with us
                                </p>
                            </div>
                        </div> }
                    </div>
                </Card.Body>
            </Card>
        )
    }
}